import { createSelector } from 'reselect';

export const getOnsiteBookingLoadingStatus = createSelector(
  state => state.onsiteBooking.loadingStatus,
  loadingStatus => loadingStatus || false,
);

export const getOnsiteBookingPatientInfo = createSelector(
  state => state.onsiteBooking.patientInfo,
  patientInfo => patientInfo || null,
);

export const getOnsiteBookingTimeSlot = createSelector(
  state => state.onsiteBooking.onsiteBookingData,
  onsiteBookingData => onsiteBookingData || null,
);

export const getCurrentHoldingSlot = state =>
  state.onsiteBooking.currentHoldingSlot;

export const getSelectedBookingData = createSelector(
  state => state.onsiteBooking.selectedBookingSlot.bookingData,
  bookingData => bookingData || null,
);

export const getSelectedBookingSlot = createSelector(
  state => state.onsiteBooking.selectedBookingSlot,
  selectedBookingSlot => selectedBookingSlot || null,
);
